export default "__VITE_ASSET__a0375Kws__"